import React, { useEffect, useState } from 'react';
import supabaseService from '../../services/supabaseService';

const MainRedirect = () => {
  const [redirecting, setRedirecting] = useState(true);

  useEffect(() => {
    const handleDomainRedirect = async () => {
      try {
        const currentDomain = window.location.hostname;
        console.log('🌐 MainRedirect: Current domain:', currentDomain);

        // Check if this is a configured short link domain
        const domains = await supabaseService.loadDomains();
        const domainConfig = domains.find(d => d.domain === currentDomain);

        if (domainConfig && domainConfig.defaultDestinationUrl) {
          console.log('🔄 MainRedirect: Found domain config, redirecting to:', domainConfig.defaultDestinationUrl);
          window.location.href = domainConfig.defaultDestinationUrl;
          return;
        }

        // Default fallback
        console.log('🔄 MainRedirect: No domain config found, redirecting to trialconnx.com');
        window.location.href = 'https://trialconnx.com';

      } catch (error) {
        console.error('❌ MainRedirect: Error loading domain config:', error);
        // Fallback on error
        window.location.href = 'https://trialconnx.com';
      }
    };

    handleDomainRedirect();
  }, []);

  return (
    <div className="redirect-container">
      <div className="redirect-content">
        <div className="spinner"></div>
        <h2>Redirecting...</h2>
        <p>Taking you to trialconnx.com</p>
      </div>

      <style jsx>{`
        .redirect-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .redirect-content {
          background: white;
          padding: 40px;
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          text-align: center;
          max-width: 400px;
          width: 90%;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #f3f4f6;
          border-top: 4px solid #667eea;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 20px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        h2 {
          color: #333;
          margin-bottom: 10px;
          font-size: 24px;
          font-weight: 600;
        }

        p {
          color: #666;
          font-size: 16px;
          line-height: 1.5;
          margin: 0;
        }
      `}</style>
    </div>
  );
};

export default MainRedirect;